<template>
  <div>
    <div
      :id="id"
      v-loading="loading"
      style="height: 100%; width: 100%"
      class="vegaContain"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    ></div>
    <vxe-modal
      v-model="dialogVisible"
      title="市场情报"
      width="800px"
      show-zoom
      resize
      transfer
      draggable
      destroy-on-close
    >
      <div style="max-height: 60vh">
        <v-card v-for="(item, index) in curEvents" style="margin-top: 10px">
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                  style="text-overflow: inherit; white-space: break-spaces"
                  >{{ "公司名称：" + item.GE8000095E }}</v-list-item-title
                >
                <v-list-item-title
                  style="text-overflow: inherit; white-space: break-spaces"
                  >{{ "情报类型：" + item.GE8000087E }}</v-list-item-title
                >
                <v-list-item-title
                  style="text-overflow: inherit; white-space: break-spaces"
                  >{{ "情报标题：" + item.GE8000088E }}</v-list-item-title
                >
                <v-list-item-subtitle
                  style="text-overflow: inherit; white-space: break-spaces"
                  >{{ "情报摘要：" + item.GE8000093E }}</v-list-item-subtitle
                >
                <v-list-item-subtitle>{{
                  "时间：" + item.GE8000089E
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="deep-purple lighten-2" small @click="btntuili(item)">
              推理图谱
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </vxe-modal>
  <dialogTimeLine ref="myTimeLine"></dialogTimeLine>
  </div>
</template>

<script>
import * as vega from "vega";
import userDocApi from "@/assets/js/userDocApi.js";
import dialogTimeLine from "./dialogTimeLine.vue";
import apiAxios from "@/config/apiAxios";
export default {
  name: "intelCenter",
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
  },
  components: {dialogTimeLine},

  data() {
    return {
      vegaView: {},
      loading: true,
      dialogVisible: false,
      curEvents: [],
      vegaDefaultConfig: {
        $schema: "https://vega.github.io/schema/vega/v5.json",
        description:
          "A heatmap showing average daily temperatures in Seattle for each hour of the day.",
        width: 500,
        height: 300,
        padding: 0,
        autosize: "fit",

        title: {
          text: "市场情报(最近四周)",
          color: "#fff",
          subtitleColor: "#fff",
          anchor: "middle",
          align: "center",
          fontSize: 16,
          frame: "group",
        },
        config: {
          locale: {
            time: {
              periods: ["上午", "下午"],
              days: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              shortDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
              months: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
              shortMonths: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
            },
          },
        },
        signals: [
          {
            name: "palette",
            value: "blues",
          },
          {
            name: "width",
            update: "containerSize()[0]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[0]",
              },
            ],
          },
          {
            name: "height",
            update: "containerSize()[1]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[1]",
              },
            ],
          },
          {
            name: "weeks",
            value: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          },
        ],

        data: [
          {
            name: "eventstream",
            values: [],
            transform: [
              {
                type: "formula",
                expr: "datetime(datum.GE8000089E)",
                as: "date",
              },
              {
                type: "filter",
                expr:
                  "datum.date>datetime(year(now()),month(now()),date(now())-day(now())-21+1)",
              },
              {
                type: "timeunit",
                field: "date",
                units: ["year", "week"],
                signal: "tbin",
              },
              {
                type: "formula",
                expr: "datetime(year(datum.unit0),month(datum.unit0),date(datum.unit0))",
                as: "unit0",
              },
              {
                type: "formula",
                expr: "weeks[if(day(datum.date)===0,6,day(datum.date)-1)]",
                as: "day",
              },
              {
                type: "formula",
                expr:
                  "if(day(datum.date)===0,datetime(year(datum.unit0),month(datum.unit0),date(datum.unit0)-7),datum.unit0)",
                as: "unit0",
              },
              {
                type: "aggregate",
                fields: ["unit0"],
                groupby: ["unit0", "unit1", "day"],
                ops: ["values"],
                as: ["events"],
              },
              {
                type: "formula",
                expr: "datum.events.length",
                as: "count",
              },
              {
                type: "collect",
                sort: { field: ["unit0", "day"] },
              },
            ],
          },
        ],

        scales: [
          {
            name: "x",
            type: "band",
            domain: {
              signal: "weeks",
            },
            range: "width",
          },
          {
            name: "y",
            type: "band",
            domain: {
              signal:
                "timeSequence(tbin.unit, datetime(year(now()),month(now()),date(now())-28), datetime(year(now()),month(now()),date(now())))",
            },
            range: "height",
          },
          {
            name: "color",
            type: "linear",
            range: { scheme: { signal: "palette" } },
            domain: { data: "eventstream", field: "count" },
            zero: false,
            nice: true,
          },
        ],

        axes: [
          { orient: "bottom", scale: "x", titleColor: "#fff", labelColor: "#fff" },
          {
            orient: "left",
            scale: "y",
            titleColor: "#fff",
            labelColor: "#fff",
            labels: false,
            ticks: false,
            tickBand: "extent",
          },
        ],
        marks: [
          {
            type: "rect",
            from: { data: "eventstream" },
            encode: {
              enter: {
                width: { scale: "x", band: 1 },
                tooltip: {
                  signal:
                    "timeFormat(datum.events[0].date,'%Y年%B%d日 ')+datum.count+'条'",
                },
              },
              update: {
                x: { scale: "x", field: "day" },
                yc: { scale: "y", field: "unit0", band: 0.5 },
                height: { scale: "y", band: 1 },
                fill: { scale: "color", field: "count" },
              },
            },
          },{
      "type": "text",
      "from": {"data": "eventstream"},
      "encode": {
        "enter": {
          "fill": {"value": "#fff"},
          "align": {"value": "left"},
          "baseline": {"value": "middle"},
          "text": {"signal": "timeFormat(datum.events[0].date,'%B%d日')"}

        },
		 "update": {
            "x": {"scale": "x", "field": "day","offset":5},
            "y": {"scale": "y", "field": "unit0", "band": 0.5}

          }
      }


          }
        ],
      },
      eventstreamData: [],
    };
  },
  methods: {
    vegaInit() {
      let width = document.getElementById(this.id).clientWidth;
      let height = document.getElementById(this.id).clientHeight;
      this.vegaDefaultConfig.width = width;
      this.vegaDefaultConfig.height = height;
      let aa = vega.parse(this.vegaDefaultConfig);
      var view = new vega.View(vega.parse(this.vegaDefaultConfig))
        .renderer("svg")
        .initialize("#" + this.id)
        .hover()
        .run();
      this.loading = false;
      this.vegaView = view;
      let that = this;
      view.addEventListener("click", function (event, item) {
        that.curEvents = item.datum.events;

        that.dialogVisible = true;
        console.log(item);
      });
      view.addEventListener("touchstart", function (event, item) {
        that.curEvents = item.datum.events;

        that.dialogVisible = true;
        console.log(item);
      });
    },
    getIntelData(date, isUpdateVega = false) {
      let path = `usys/cmdw/100000000027605129/${date}/GM00012324.json`;
      userDocApi.getBoardConf(path, (_r) => {
        if (_r.code == 404) {
        } else {
          let aa = this.eventstreamData.concat(Object.values(_r)[0]);

          this.eventstreamData = aa;
          this.vegaView
            .data("eventstream", [...aa])
            .resize()
            .run();
        }
        if (isUpdateVega) {
          console.log(this.eventstreamData);
        }
      });
    },
    // 推理图谱按钮
    btntuili(item) {
      let url=`${config.serverUrl}/cmcf/v1/logs/dplc?path=${item.GE8000091E}`
            apiAxios.get(url,{},_r=>{
              if(_r.code==200){
                this.$refs.myTimeLine.getData(_r.data);
              }else{
                this.$notify({ type: 'danger', message: '获取数据失败' })
              }

            })

    },
    //判断个人的机构名称是否准确
    checkUserCompany() {
      let _that = this
      let userInfo = sessionStorage.getItem('USER_INFO') || localStorage.getItem('USER_INFO')
      if (userInfo) {
        let company = JSON.parse(userInfo)['company']
        if(company) {
          let url = `${config.serverUrl}/apm/v1/ability/api000174`
          let params = {
            "limit": 10,
            "skip": 0,
            "tags": ["机构名称_" + company]
          }
          apiAxios.post(url, params, _r => {
            if (_r.code == 200 && _r.data.total) {
              //校验成功
              _that.getIntelDataPath()
            } else {
              this.$notify({ type: "danger", message: "请完善您的个人信息-机构名称" });
            }
            console.log(_r);
          })
        }
      }
    },
    // 获取网盘文件path
    getIntelDataPath() {
      let _that = this
      let url = `${config.serverUrl}/cmss/v1/comp-service/apm/sync/cmd/ability/api000176`
      let today = $func.getToday()
      let params = {
        "ldName": "GM00012324",
        "queryCondtions": [
          {
            "startDate" : $func.getBeforeDate(today, 26),
            "endDate" : today
          }
        ]
      }
      apiAxios.post(url, params, _r => {
        if (_r.code == 200 && _r.data.path) {
          _that.getIntelDataByPath(_r.data.path.substr(1))
        } else {

        }
      })
    },
    getIntelDataByPath(path, isUpdateVega = false) {
      userDocApi.getBoardUserResource(path, (_r) => {
        if (_r.code == 404) {
        } else {
          let arr = Object.values(_r)
          arr.forEach((item,index)=>{
            item['GE8000086T'].forEach((item1)=>{
              let aa = this.eventstreamData.concat(item1);
              this.eventstreamData = aa;
              this.vegaView
                  .data("eventstream", [...aa])
                  .resize()
                  .run();
            })

          })
        }
      });
    },
  },
  mounted() {
    this.vegaInit();
    let today = $func.getToday();
    let nextday=$func.getNextDate();
    let dataArr = [
     nextday,
      today,
      $func.getBeforeDate(today, 1),
      $func.getBeforeDate(today, 2),
      $func.getBeforeDate(today, 3),
      $func.getBeforeDate(today, 4),
      $func.getBeforeDate(today, 5),
      $func.getBeforeDate(today, 6),
      $func.getBeforeDate(today, 7),
      $func.getBeforeDate(today, 8),
      $func.getBeforeDate(today, 9),
      $func.getBeforeDate(today, 10),
      $func.getBeforeDate(today, 11),
      $func.getBeforeDate(today, 12),
      $func.getBeforeDate(today, 13),
      $func.getBeforeDate(today, 14),
      $func.getBeforeDate(today, 15),
      $func.getBeforeDate(today, 16),
      $func.getBeforeDate(today, 17),
      $func.getBeforeDate(today, 18),
      $func.getBeforeDate(today, 19),
      $func.getBeforeDate(today, 20),
      $func.getBeforeDate(today, 21),
      $func.getBeforeDate(today, 22),
      $func.getBeforeDate(today, 23),
      $func.getBeforeDate(today, 24),
      $func.getBeforeDate(today, 25),
      $func.getBeforeDate(today, 26),
      // $func.getBeforeDate(today, 27),
    ];
    let that = this;
    dataArr.map(function (d, index) {
      if (index != 14) {
        that.getIntelData(d);
      } else {
        that.getIntelData(d, true);
      }
    });
    console.log(dataArr);
   // this.checkUserCompany()
  },
};
</script>

<style></style>
